import '~/assets/scss/analytic-index.scss'

import PageProduct from '~/js/modules/page-product';

import '~/js/modules/switches';
import '~/js/modules/tabs';
import SwitchStock from '~/js/modules/switch-stock';

new PageProduct();

window.addEventListener(`DOMContentLoaded`, () => {


  const value__price_arr = document.querySelectorAll(`.value__price`);
  value__price_arr.forEach(function(item, i, arr) {
    if (+item.textContent < 0) {
      item.parentElement.parentElement.parentElement.classList.remove('charts__table-cell--profit');
      item.parentElement.parentElement.parentElement.classList.add('charts__table-cell--loss');
    }
  });

  const arrow__dropdowns = document.querySelectorAll('.js-toggle-nav');
  if(arrow__dropdowns) {
    arrow__dropdowns.forEach((item) => {
      item.addEventListener('click', () => {
        item.parentElement.classList.toggle('active');
      })
    });
  }

  const stock = document.querySelectorAll(`.js-stocks-container`);

  if (stock) {
    new SwitchStock({ container: 'stocksA', mode: 'slider' });
  }
});
